import { Widowhood } from 'shell/models/person/widowhood';
import { transformEventData } from '../event-datas-shared';
import { AccordionWidowhood } from 'shell/components/shared/sipo-person-form/new-person';

export const transformWidowhood = (
  values: AccordionWidowhood | undefined
): Widowhood | undefined => {
  const {
    isForeign,
    eventDate,
    eventChoiceDate,
    exceptionalLocation,
    municipality,
    year,
    province,
    documentNumber,
    portion,
    range,
    regVol,
    office,
    documentDate,
    transcript,
  } = values || {};

  const datiMorteconiuge = transformEventData({
    isForeign,
    eventDate,
    eventChoiceDate,
    exceptionalLocation,
    municipality,
    year,
    province,
    documentNumber,
    portion,
    range,
    regVol,
    office,
    documentDate,
    transcript,
    location: {
      exceptionalLocation: values?.exceptionalLocation || '',
      localita:
        (!values?.isForeign
          ? values?.italian?.location
          : values?.foreign?.municipality?.description) || '',
      foreignState: values?.foreign?.state,
      municipality: values?.italian?.municipality,
    },
  });

  const originReturnData: Widowhood | undefined = values
    ? {
        datiMorteconiuge,
        ordineMatrimonioPrecedente: values?.number?.toString() || '',
      }
    : undefined;

  return originReturnData;
};
